import firebase from 'firebase';
import { Competition } from '../interfaces/Competition';

// Initial-load data for a freshly selected home-page division. No timed cache.
// Lists are consumed once; entries are shared by the initial team/match loaders.
// The view clears everything on completion, error, tab change or unmount.
export class InitialCompetitionData {
    private snapshots = new Map<string, firebase.database.DataSnapshot>();

    constructor(snapshot: firebase.database.DataSnapshot) {
        this.snapshots.set('matches', snapshot.child('matches'));
        this.snapshots.set('entries', snapshot.child('entries'));
        snapshot.child('entries').forEach(child => {
            this.snapshots.set(`entries/${child.key}`, child);
            return false;
        });
    }

    take(path: string): firebase.database.DataSnapshot | undefined {
        const snapshot = this.snapshots.get(path);
        this.snapshots.delete(path);
        return snapshot;
    }

    entry(id: string): firebase.database.DataSnapshot | undefined {
        return this.snapshots.get(`entries/${id}`);
    }

    clear() {
        this.snapshots.clear();
    }

    discard(path: string) {
        this.snapshots.delete(path);
        if (path === 'entries') {
            this.snapshots.forEach((_, key) => {
                if (key.startsWith('entries/')) this.snapshots.delete(key);
            });
        }
    }
}

export const initialCompetitionData = new WeakMap<Competition, InitialCompetitionData>();
